import { makeStyles } from '@material-ui/core';
import { Grid, Typography } from '@material-ui/core/';
import React, { useState } from 'react';
import { required, SelectInput, TextInput } from 'react-admin';

import OrganizationApi from '../../core/apis/OrganizationApi';
import {
  isStringAlphaNumericUnderscoreHyphen,
  fieldLengthValidator,
  isStringOnlyUnderscoreHyphen
} from '../../core/utils/index';
import { organizationStatus } from './OrganizationLookups';

const useStyles = makeStyles({
  headerContainer: {
    paddingTop: '0px !important'
  }
});

const OrganizationSummary = props => {
  const [formErrors, setFormErrors] = useState({});
  const classes = useStyles();
  const { variant, creation } = props;

  /*
   * Verify that Family ID is unique and alpha numeric,
   * also check if ID is not made just from Underscore and Hyphens
   */
  const validateOrganizationId = async (value, allValues, props) => {
    if (props.active) {
      const idValid = isStringAlphaNumericUnderscoreHyphen(value);
      const isValueOnlyUnderscoreHyphen = isStringOnlyUnderscoreHyphen(value);
      let error;

      if (!idValid) {
        error =
          'Family ID must be unique and only contain numbers letters, underscore and hyphen symbols without any spaces';
      } else if (!isValueOnlyUnderscoreHyphen) {
        error =
          'Family ID must contain at least one number or letter character';
      } else {
        const idExists = await OrganizationApi.checkIdExists(value);

        if (idExists) {
          error = 'ID already exists';
        } else {
          error = undefined;
        }
      }
      setFormErrors({ ...formErrors, id: error });
      return error;
    }
    return formErrors.id;
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.headerContainer}>
          <Typography variant="h5">Investor Family Details</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="name"
            label="Family Name"
            validate={[required(), fieldLengthValidator(256)]}
            options={{ autoComplete: 'off' }}
            variant={variant}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="aka"
            label="A.K.A"
            options={{ autoComplete: 'off' }}
            variant={variant}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <SelectInput
            source="status"
            label="Status"
            choices={organizationStatus}
            validate={[required()]}
            variant="standard"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="id"
            label="Family ID"
            validate={[
              required(),
              fieldLengthValidator(20),
              validateOrganizationId
            ]}
            disabled={!creation}
            options={{ autoComplete: 'off' }}
            variant={variant}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default OrganizationSummary;
